interface Props {
  value: string
  onChange: (value: string) => void
  maxLength?: number
  linkPreview?: string
}

const variables = [
  { key: '{{username}}', label: 'Username', description: 'Commenter\'s IG username' },
  { key: '{{first_name}}', label: 'First Name', description: 'Commenter\'s first name (falls back to username)' },
  { key: '{{keyword}}', label: 'Keyword', description: 'The matched keyword' },
  { key: '{{link}}', label: 'Link', description: 'The attached short URL' },
]

export function MessageTemplateEditor({ value, onChange, maxLength = 500, linkPreview }: Props) {
  const insertVariable = (variable: string) => {
    onChange(value + variable)
  }

  // Render preview with variables highlighted
  const preview = value
    .replace(/\{\{username\}\}/gi, '@johndoe')
    .replace(/\{\{first_name\}\}/gi, 'John')
    .replace(/\{\{keyword\}\}/gi, 'INFO')
    .replace(/\{\{link\}\}/gi, linkPreview ?? 'https://urlzippy.com/abc123')

  return (
    <div className="space-y-3">
      <div>
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Message Template</label>
        <textarea
          value={value}
          onChange={e => onChange(e.target.value.slice(0, maxLength))}
          rows={4}
          className="w-full px-3 py-2 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-[#0d121b] text-gray-900 dark:text-white resize-none font-mono"
          placeholder="Hey {{username}}! Thanks for your interest..."
        />
        <p className="text-xs text-gray-400 mt-1">{value.length}/{maxLength}</p>
      </div>

      {/* Variable buttons */}
      <div className="flex flex-wrap gap-2">
        {variables.map(v => (
          <button
            key={v.key}
            type="button"
            onClick={() => insertVariable(v.key)}
            className="px-2.5 py-1 text-xs bg-gray-100 dark:bg-white/5 text-gray-600 dark:text-gray-400 border border-gray-200 dark:border-white/10 rounded-lg hover:bg-gray-200 dark:hover:bg-white/10 transition-colors"
            title={v.description}
          >
            <code>{v.key}</code>
          </button>
        ))}
      </div>

      {/* Live preview */}
      {value && (
        <div>
          <label className="block text-xs font-medium text-gray-500 dark:text-gray-400 mb-1">Preview</label>
          <div className="p-3 bg-gray-50 dark:bg-[#0d121b] border border-gray-200 dark:border-white/10 rounded-lg">
            <div className="flex gap-2">
              <div className="w-6 h-6 rounded-full bg-gradient-to-tr from-purple-500 to-pink-500 shrink-0" />
              <div>
                <p className="text-xs font-medium text-gray-700 dark:text-gray-300">Your Business</p>
                <p className="text-sm text-gray-900 dark:text-white mt-0.5 whitespace-pre-wrap">{preview}</p>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
